/*
  Colour swatches on product pages (snippets/color-swatches.liquid).
  Loads the products sharing the base SKU and product type from the shop search
  (templates/search.swatches.liquid) and links them as image swatches.
*/
(() => {
  const warn = (...args) => console.warn('[Farbvarianten]', ...args);

  const loadSwatches = async (container) => {
    if (container.dataset.swatchesLoaded) return;
    container.dataset.swatchesLoaded = 'true';

    const params = new URLSearchParams({
      q: container.dataset.searchTerm.trim(),
      type: 'product',
      view: 'swatches',
      'options[prefix]': 'last',
      'options[unavailable_products]': 'last',
    });

    const url = `${container.dataset.searchUrl}?${params}`;
    let products;
    try {
      const response = await fetch(url);
      if (!response.ok) {
        warn(`Search failed (HTTP ${response.status}):`, url);
        return;
      }
      products = await response.json();
    } catch (error) {
      warn('Search did not return the swatch data (search.swatches template missing?):', url, error);
      return;
    }

    if (!Array.isArray(products)) return;

    // Same base SKU, and same product type: a few base SKUs are shared by
    // different products (e.g. ring and hair clip)
    products = products.filter(
      (product) => product.base === container.dataset.baseSku && product.type === container.dataset.productType
    );
    if (products.length < 2) {
      console.info('[Farbvarianten]', `No other colours for ${container.dataset.baseSku}:`, url);
      return;
    }

    products.sort((a, b) => a.sku.localeCompare(b.sku));

    const list = container.querySelector('[data-color-swatches-list]');
    products.forEach((product) => {
      const isCurrent = product.handle === container.dataset.currentHandle;
      const name = product.color || product.title;

      const item = document.createElement('li');
      item.className = 'color-swatches__item';

      const swatch = document.createElement(isCurrent ? 'span' : 'a');
      swatch.className = 'color-swatches__swatch';
      swatch.title = name;
      if (isCurrent) {
        swatch.classList.add('is-active');
        swatch.setAttribute('aria-current', 'true');
      } else {
        swatch.href = product.url;
      }
      if (!product.available) swatch.classList.add('is-sold-out');

      if (product.image) {
        const image = document.createElement('img');
        image.src = product.image;
        image.alt = '';
        image.width = 60;
        image.height = 60;
        image.loading = 'lazy';
        swatch.appendChild(image);
      }

      const label = document.createElement('span');
      label.className = 'visually-hidden';
      label.textContent = name;
      swatch.appendChild(label);

      item.appendChild(swatch);
      list.appendChild(item);
    });

    container.hidden = false;
  };

  document.querySelectorAll('[data-color-swatches]').forEach(loadSwatches);
})();
